/**
 * @generated SignedSource<<2811cc6469d29c2f7ad7d7bc73363908>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type suggestions_periscope_WorkSuggestionsAutoDevJobSwitcher_node$data = {
  readonly __typename: "WorkSuggestionsAutoDevJobsPlanSuccessTask";
  readonly " $fragmentSpreads": FragmentRefs<"planningSuccess_periscope_AutoDevJobsPlanningSuccess">;
  readonly " $fragmentType": "suggestions_periscope_WorkSuggestionsAutoDevJobSwitcher_node";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "suggestions_periscope_WorkSuggestionsAutoDevJobSwitcher_node";
};
export type suggestions_periscope_WorkSuggestionsAutoDevJobSwitcher_node$key = {
  readonly " $data"?: suggestions_periscope_WorkSuggestionsAutoDevJobSwitcher_node$data;
  readonly " $fragmentSpreads": FragmentRefs<"suggestions_periscope_WorkSuggestionsAutoDevJobSwitcher_node">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "suggestions_periscope_WorkSuggestionsAutoDevJobSwitcher_node",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "planningSuccess_periscope_AutoDevJobsPlanningSuccess"
        }
      ],
      "type": "WorkSuggestionsAutoDevJobsPlanSuccessTask"
    }
  ],
  "type": "WorkSuggestionsAutoDevJobTask",
  "abstractKey": "__isWorkSuggestionsAutoDevJobTask"
};

(node as any).hash = "c4b28b305c931c53d60531754126c4af";

export default node;
